import Home from '../../views/Home/Home'

export default [
    {
        path: '/',
        name: 'home',
        component: Home
    }
]